if (!customElements.get('vt-mobile-app-bar')) {
  class VtMobileAppBar extends HTMLElement {
  constructor() {
    super();
    this.mql = window.matchMedia('(max-width: 749px)');
    this.onMediaChange = this.onMediaChange.bind(this);
    this.onAction = this.onAction.bind(this);
  }

  connectedCallback() {
    this.ensureDockedToBody();
    if (this._vtAppBarReady) return;
    this._vtAppBarReady = true;

    this.items = this.querySelectorAll('[data-action]');
    this.cartCount = this.querySelector('[data-cart-count]');
    this.menuButton = this.querySelector('[data-action="menu"]');
    this.items.forEach((item) => item.addEventListener('click', this.onAction));
    this.mql.addEventListener('change', this.onMediaChange);
    this.onMediaChange();
    this.observeCartBubble();
    this.observeMenuState();
    this.cacheHeaderTargets();
  }

  ensureDockedToBody() {
    if (this.parentElement === document.body) {
      this.dataset.docked = 'true';
      return;
    }
    if (this.dataset.docked === 'true') return;
    this.dataset.docked = 'true';
    document.body.appendChild(this);
  }

  cacheHeaderTargets() {
    this.searchModal = this.getSearchModal();
    this.menuDrawer = document.querySelector('header-drawer');
    this.menuDetails = document.getElementById('Details-menu-drawer-container');
    this.menuSummary = this.menuDetails?.querySelector('summary.header__icon--menu');
    this.cartDrawer = document.querySelector('cart-drawer');
    this.cartIcon = document.querySelector('#cart-icon-bubble');
  }

  disconnectedCallback() {
    this._vtAppBarReady = false;
    this.items?.forEach((item) => item.removeEventListener('click', this.onAction));
    this.mql.removeEventListener('change', this.onMediaChange);
    this.cartObserver?.disconnect();
    this.menuObserver?.disconnect();
  }

  onMediaChange() {
    const isMobile = this.mql.matches;
    this.hidden = !isMobile;
    this.toggleAttribute('data-mobile', isMobile);
    if (isMobile) {
      this.cacheHeaderTargets();
      this.syncCartCount();
      this.syncMenuState();
    }
  }

  onAction(event) {
    const item = event.currentTarget;
    const action = item.dataset.action;

    if (action === 'home' || action === 'account') {
      return;
    }

    if (action === 'cart' && item.tagName === 'A') {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.cacheHeaderTargets();

    switch (action) {
      case 'search':
        this.openSearch();
        break;
      case 'menu':
        this.openMenu();
        break;
      case 'cart':
        this.openCart(item);
        break;
      default:
        break;
    }
  }

  getSearchModal() {
    return (
      document.querySelector('.header__icons details-modal.header__search') ||
      document.querySelector('details-modal.header__search') ||
      null
    );
  }

  getSearchSummary() {
    const modal = this.getSearchModal();
    return modal?.querySelector('summary.header__icon--search') || modal?.querySelector('summary');
  }

  openSearch() {
    const modal = this.getSearchModal();
    const summary = this.getSearchSummary();
    if (!modal || !summary) return;

    if (typeof modal.isOpen === 'function' && modal.isOpen()) {
      summary.focus();
      return;
    }

    // Defer so Dawn's details-modal body click handler does not close search
    // on the same tap that opened it from the app bar.
    window.setTimeout(() => {
      summary.click();
    }, 0);
  }

  openMenu() {
    const drawer = this.menuDrawer || document.querySelector('header-drawer');
    const details = this.menuDetails || document.getElementById('Details-menu-drawer-container');
    const summary = this.menuSummary || details?.querySelector('summary.header__icon--menu');

    if (!drawer || !details || !summary) return;

    const isOpen = details.hasAttribute('open') && details.classList.contains('menu-opening');
    if (isOpen) return;

    if (!details.hasAttribute('open')) {
      details.setAttribute('open', '');
    }

    if (typeof drawer.openMenuDrawer === 'function') {
      drawer.openMenuDrawer(summary);
      return;
    }

    summary.click();
  }

  openCart(trigger) {
    const cartDrawer = this.cartDrawer || document.querySelector('cart-drawer');

    if (cartDrawer?.open) {
      cartDrawer.open(trigger);
      return;
    }

    const cartIcon = this.cartIcon || document.querySelector('#cart-icon-bubble');
    if (cartIcon) {
      cartIcon.click();
      return;
    }

    window.location.href = window.routes?.cart_url || '/cart';
  }

  observeCartBubble() {
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (!cartIcon || !this.cartCount) return;

    this.syncCartCount();
    this.cartObserver = new MutationObserver(() => this.syncCartCount());
    this.cartObserver.observe(cartIcon, { childList: true, subtree: true, characterData: true });
  }

  observeMenuState() {
    const details = this.menuDetails || document.getElementById('Details-menu-drawer-container');
    if (!details || !this.menuButton) return;

    this.syncMenuState();
    this.menuObserver = new MutationObserver(() => this.syncMenuState());
    this.menuObserver.observe(details, { attributes: true, attributeFilter: ['open', 'class'] });
  }

  syncMenuState() {
    const details = this.menuDetails || document.getElementById('Details-menu-drawer-container');
    if (!details || !this.menuButton) return;

    const isOpen = details.hasAttribute('open') && details.classList.contains('menu-opening');
    this.menuButton.classList.toggle('is-open', isOpen);
  }

  syncCartCount() {
    if (!this.cartCount) return;

    const cartIcon = document.querySelector('#cart-icon-bubble');
    const headerCount = cartIcon?.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    const count = headerCount?.textContent?.trim();
    const countEl = this.cartCount.querySelector('span[aria-hidden="true"]');

    if (count && countEl) {
      countEl.textContent = count;
      this.cartCount.hidden = false;
    } else {
      this.cartCount.hidden = true;
      if (countEl) countEl.textContent = '';
    }

    this.syncCartIcon(cartIcon);
  }

  syncCartIcon(cartIcon) {
    const appBarCartIcon = this.querySelector('.vt-app-bar__cart-icon .svg-wrapper');
    const headerSvgWrap = cartIcon?.querySelector('.svg-wrapper');
    if (!appBarCartIcon || !headerSvgWrap) return;

    if (appBarCartIcon.innerHTML !== headerSvgWrap.innerHTML) {
      appBarCartIcon.innerHTML = headerSvgWrap.innerHTML;
    }
  }
  }

  customElements.define('vt-mobile-app-bar', VtMobileAppBar);
}
